import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56d2e832"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Example Preview", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cursor" }, "█", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_IconButton, {
      icon: "LightBulbIcon",
      title: "Toggle dark/light preview",
      onClick: _ctx.togglePreview
    }, null, 8, ["onClick"]),
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass(["preview", { light: _ctx.light, dark: !_ctx.light }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (element) => {
        return (_openBlock(), _createElementBlock("span", {
          key: element.id,
          style: _normalizeStyle({
        backgroundColor: (element.data.attributes.reverse
          ? element.data.foregroundColor?.hex ?? (_ctx.light ? '#212121' : '#fafafa')
          : element.data.backgroundColor?.hex ?? (_ctx.light ? '#fafafa' : '#212121')) + ' !important',
      })
        }, [
          (element.data.type.preview(element.data.parameters) !== '\n')
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                style: _normalizeStyle({
          color: (element.data.attributes.reverse
            ? element.data.backgroundColor?.hex ?? (_ctx.light ? '#fafafa' : '#212121')
            : element.data.foregroundColor?.hex ?? (_ctx.light ? '#212121' : '#fafafa')) + ' !important',
        }),
                class: _normalizeClass({
          'preview-bold': element.data.attributes.bold,
          'preview-dim': element.data.attributes.dim,
          'preview-italic': element.data.attributes.italic,
          'preview-underline': element.data.attributes.underline,
          'preview-blink': element.data.attributes.blink,
          'preview-overline': element.data.attributes.overline,
        })
              }, _toDisplayString(_ctx.bsSlicer(element.data.type.preview(element.data.parameters), element.data.backspaces)), 7))
            : (_openBlock(), _createElementBlock("br", _hoisted_3))
        ], 4))
      }), 128)),
      _hoisted_4
    ], 2)
  ], 64))
}